// src/services/expireApi.js
import { api } from "./client";
import { toast } from "react-toastify"; // Ensure toast is configured in App.js
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
// const lang = localStorage.getItem('lang') || 'en';


// Fetch all expired products
export const fetchExpiredProducts = async () => {
  try {
    const lang = localStorage.getItem('lang') || 'en'; // ✅ FIXED

    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Accept-Language': lang
      }
    };

    const response = await api.get(`${API_BASE_URL}api/expire/product-list`, config);
    console.log("✅ Expired product list response:", response.data); // Debug
    return response.data; // check whether .data or .data.data is correct
  } catch (error) {
    console.error("❌ Error fetching expired products:", error);
    toast.error(`${window.translate("Failed to fetch expired products.")}`);
    return [];
  }
};




// Update a product by ID
export const updateProductById = async (id, productData) => {
  try {
    const response = await api.put(`${API_BASE_URL}api/expire/product/${id}`, productData);
    // toast.success("Product updated successfully.");
    return response.data;
  } catch (error) {
    console.error("Error updating product:", error);
    toast.error(`${window.translate("Failed to update product")}`);
    throw error; // optional: allow higher-level handling
  }
};

// Fetch product name by ID (for dropdowns or forms)
export const fetchProductNameById = async (id) => {
  try {
    const response = await api.get(`${API_BASE_URL}api/expire/product-name/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching product name by ID:", error);
    toast.error(`${window.translate("Failed to fetch product name.")}`);
    return null;
  }
};

// Delete a product by ID and move it to OutOfStock
export const deleteProductById = async (id) => {
  try {
    const response = await api.delete(`${API_BASE_URL}api/expire/product/${id}`);
   toast.success(window.translate("Product deleted and moved to Out of Stock."));
    return response.data;
  } catch (error) {
    console.error("Error deleting product:", error);
    toast.error(error?.response?.data?.message || `${window.translate("Failed to delete product")}`);
    throw error;
  }
};
